module.exports = __webpack_public_path__ + "static/media/S_S01.cf82170b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/S_S01.png
// module id = 109
// module chunks = 0